module.exports = __webpack_public_path__ + "img/ic-collapse.800486e2.svg";